export enum NotificationChannelEnum {
    Sms = 1,
    Email = 2,
    PushNotification = 3
}